import { PDFDownloadLink, PDFViewer } from '@react-pdf/renderer';
import FacturePDF from '../../components/facture-pdf/FacturePDF';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import { calculateTotalFrais, fetchFacture } from '../../data/slices/factureSlice';
import { Stack, Typography, Radio, RadioGroup, FormControlLabel, FormControl, FormLabel } from '@mui/material';
import WestIcon from '@mui/icons-material/West';
import { COLORS, output, toFrench } from '../../settings/themeSettings';

const RecuViewer = () => {
    const { id, clientId } = useParams();
    const [facture, setFacture] = useState({});
    const [priceToFrench, setPriceToFrench] = useState(null);
    const [paiements, setPaiements] = useState(0);
    const [bankOption, setBankOption] = useState('sgbs');

    const navigateTo = useNavigate();
    const [loading, setLoading] = useState(false);


    useEffect(() => {
        setLoading(true);
        fetchFacture(id).then((response) => {
                const facture = response.data;
                // output(resp);
                setLoading(false);
                setFacture(facture);
            })
            .catch(err => {
                setLoading(false);

                output(err);
            })
            ;
    }, []);

    useEffect(() =>{

        if(facture && facture.paiements && facture.paiements.length > 0){

            setPaiements(calculateTotalFrais(facture.paiements))

        }
       

    }, 
    [facture]);


    useEffect(() =>{

        if(paiements){
            setPriceToFrench(toFrench(Number(paiements)) + ' FRANCS CFA')
        }

    }, [paiements]);



    return <div>
        <Stack
            direction="row"
            justifyContent="flex-start"
            gap="5"
            alignItems="flex-start"

        >
            <div onClick={() => navigateTo(`/billeterie/factures/${clientId}/details/${id}`)}
                style={{ background: COLORS.secondary, height: '65px', width: '65px', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: `${65 / 2}px`, cursor: 'pointer' }}>
                <WestIcon style={{ fill: 'white', fontSize: 28 }} />
            </div>
            <Typography variant="h4" sx={{ backgroundColor: COLORS.secondary, color: '#FFF', p: '10px', mb: 5, ml: 5, width: '100%' }}>Reçu PDF </Typography>

        </Stack>

        {
          (  loading  ||( facture && facture.paiements && facture.paiements.length > 0 && priceToFrench == null))?
                <div className="loader-container">
                    <span className="loader"></span>
                </div>
                :

                <div style={{ display: 'flex', flexDirection: 'column', width: '100%', height: '100vh' }}>
                    <div style={{ padding: '0 20px 20px 20px' }}>
                        <FormControl component="fieldset">
                            <FormLabel component="legend" sx={{ fontWeight: 'bold' }}>Coordonnées Bancaires à afficher sur le reçu :</FormLabel>
                            <RadioGroup
                                row
                                value={bankOption}
                                onChange={(e) => setBankOption(e.target.value)}
                            >
                                <FormControlLabel value="sgbs" control={<Radio color="primary" />} label="SGBS" />
                                <FormControlLabel value="orabank" control={<Radio color="primary" />} label="Orabank" />
                                <FormControlLabel value="none" control={<Radio color="primary" />} label="Cacher la banque" />
                            </RadioGroup>
                        </FormControl>
                    </div>
                    <PDFViewer style={{ width: '100%', flex: 1 }} >
                        <FacturePDF facture={facture} typeDocument="REÇU DE PAIEMENT" bankOption={bankOption} />
                    </PDFViewer>
                </div>
        }

      
    </div>

}



export default RecuViewer;
